import React, { useContext, useState, useEffect, useRef } from 'react'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { Button } from '@mui/material'
import { dateFormatFunction } from '@/custom/common/components'
import {
    mapData,
    converTime,
    getPickupHours,
} from '@/product/common/components'
import { useFormik } from 'formik'
import CustomCommonContext from '@/custom/context/common/commonContext'
import CustomDialog from '@/product/components/organisms/Dialog'
import CommonContext from '@/product/context/common/commonContext'
import * as Yup from 'yup'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SettingContext from '@/product/context/setting/settingContext'
import AlertContext from '@/product/context/alert/alertContext'
import UserCommonContext from '@/product/context/userCommon/commonContext'
import SettingCustomContext from '@/custom/context/setting/settingContext'
import moment from 'moment'

const LocationManage = (props) => {
    // const settingcontext = useContext(SettingContext)
    const usercommoncontext = useContext(UserCommonContext)
    const commonContext = useContext(CommonContext)
    const alertContext = useContext(AlertContext)

    const { setAlert } = alertContext

    const { USStates, allCountries, allStates, allCounties, getAllCounties } =
        commonContext

    const { allLocations, getGlobalVariable } = useContext(CustomCommonContext)
    const [isLoading, setIsLoading] = useState(true)
    const settingCustomContext = useContext(SettingCustomContext)

    // const {
    //     searchTableFetch,
    //     searchTableAction,
    //     search_fetch_data,
    //     responseStatus: responseStatusSetting,
    //     clearResponse: clearResponseCommuncation,
    // } = settingcontext
    const {
        searchTableAction,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingCustomContext

    const { getPreviousData, clearPreviousData, previous_data } =
        usercommoncontext
    const [parkingSlot, setParkingSlot] = useState([])
    const [changeStatus, setChangeStatus] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const data = props.data
    const toggleFullScreenPopup = props.function

    const validationArray = Yup.object({
        factory_name: Yup.string().required('Required!'),
        factory_code: Yup.string()
            .required('Required!') // Ensure the factory_code is required
            .max(3, 'Factory code must be at most 3 characters long'),
        start_date: Yup.date().required('Required!'),
        end_date: Yup.date()
            .required('Required!')
            .test(
                'is-greater-than-start',
                'End date must be greater than start date',
                function (value) {
                    const { start_date } = this.parent // Get start_date from the parent object

                    if (start_date && value) {
                        const startDate = new Date(start_date)
                        const endDate = new Date(value)

                        // If endDate is not greater than startDate, return false (invalid)
                        if (endDate <= startDate) {
                            return false // Invalid: endDate is not greater than startDate
                        }
                    }
                    return true // Valid: endDate is greater than startDate
                }
            ),
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            factory_name: '',
            factory_code: '',
            start_date: '',
            // where: 'factory_code',
            end_date: '',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            values.table = 'factory_codes'
            // values.factory_code = values.factory_code.trim()

            if (values.start_date) {
                const localStartDate = new Date(values.start_date)
                values.start_date = localStartDate.toLocaleDateString('en-CA') // 'en-CA' gives YYYY-MM-DD format
            }

            if (values.end_date) {
                const localEndDate = new Date(values.end_date)
                values.end_date = localEndDate.toLocaleDateString('en-CA') // 'en-CA' gives YYYY-MM-DD format
            }

            // values.uniqueValue = values.factory_code
            searchTableAction(values, false, 'factory_codes_create')
        },
    })

    useEffect(() => {
        if (responseStatusSetting) {
            if (
                responseStatusSetting.from === 'factory_codes_create' &&
                responseStatusSetting.status === 'success'
            ) {
                toggleFullScreenPopup(false)
                formik.resetForm()
            }
        }
    }, [responseStatusSetting])

    useEffect(() => {
        if (data.status != 'new') {
            formik.setFieldValue('id', data.id)
            const template =
                props?.record?.find((cat) => cat.id === data.id) || {}

            formik.setValues({
                ...formik.values,
                ...template,
                start_date: template.start_date
                    ? dateFormatFunction(template.start_date)
                    : '',
                end_date: template.end_date
                    ? dateFormatFunction(template.end_date)
                    : '',
            })
        } else {
            resetFrom()
        }
    }, [data])

    const resetFrom = () => {
        formik.setValues({
            id: 0,

            factory_code: '',
            factory_name: '',
            start_date: '',
            end_date: '',
            where: 'factory_code',
        })
    }

    const details = {
        formik: formik,
        data: [
            {
                label: 'Factory Name',
                placeholder: 'Enter Factory Name',
                type: '',
                required: true,
                class: 'col-6',
                name: 'factory_name',
            },
            {
                label: 'Factory Code',
                placeholder: 'Enter Factory Code',
                type: '',
                required: true,
                class: 'col-6',
                name: 'factory_code',
            },
            {
                label: 'Start Date',
                placeholder: 'Enter Start Date',
                type: 'date',
                required: true,
                class: 'col-6',
                name: 'start_date',
            },
            {
                label: 'End Date',
                placeholder: 'Enter End Date',
                type: 'date',
                required: true,
                class: 'col-6',
                name: 'end_date',
            },
        ],
    }

    const submitFunction = () => {
        formik.handleSubmit()
        //toggleFullScreenPopup(false)
    }
    return (
        <FullScreenPopup
            modaltitle={
                data.status === 'new'
                    ? 'Add New Factory Code'
                    : data.status === 'edit'
                    ? 'Edit Factory Code'
                    : 'Edit Factory Code'
            }
            open={data.popup}
            handleClose={() => {
                toggleFullScreenPopup(false, 'new', 0)
                formik.resetForm()
            }}
        >
            <div className="dashboard addNewListing mt-4">
                <div className="fspBody">
                    {/* <form
                            onSubmit={formik.handleSubmit}
                            autoComplete="nofill"
                        > */}
                    <div className="row">{mapData(details)}</div>

                    <div className="actionButton d-flex justify-content-center align-items-center">
                        <SecondaryButton
                            id="location_cancel"
                            label="Cancel"
                            onClick={() => {
                                toggleFullScreenPopup(false)
                                formik.resetForm()
                            }}
                        />
                        <PrimaryButton
                            id="location_submit"
                            label="Submit"
                            onClick={submitFunction}
                        />
                    </div>
                    {/* </form> */}
                </div>
            </div>
        </FullScreenPopup>
    )
}
export default LocationManage
